import { callExternalApi } from '../../callExternalApi';

export const upsertCustomFieldValuesApi = (
  entityId: string,
  entityType: string,
  values: { custom_field_definition_id: string; value: string }[]
) =>
  callExternalApi<{ id: string; entity_id: string; entity_type: string; value: string }[]>({
    url: 'api/custom_field_values/upsert',
    method: 'POST',
    data: { entity_id: entityId, entity_type: entityType, values }
  });
